import React, { Component } from 'react'
import TitleBar from '../TitleBar'
import getLabel from '../../utilities/label.js'
import IframeResizer from 'iframe-resizer-react'
import _ from 'lodash'

export default class EventEvaluation extends Component {
  constructor(props) {
    super(props)
    const backButton =
      `<i class='fa fa-arrow-left'></i> ${getLabel('back_button')}`
    this.state = {
      backButton: backButton,
    }
    this.back = this.back.bind(this)
    this.props.setActiveTab('evaluations')
    this.ensureEventContext()
    window.trackPage('EvaluationEventDetailScreen', props.match.params.id)
  }

  ensureEventContext() {
    if (this.props.location.pathname.includes('event')) {
      this.props.loadSurveyFromEmail(this.props.location.pathname)
    } else {
      localStorage.removeItem('event_survey_id')
    }
  }

  getSurvey() {
    var _this = this
    const currentEvent = _.find(this.props.events.events, (event) => {
      if (event.id === window.currentUser.current_event_id) {
        return event
      }
    })
    const survey = _.find(currentEvent.event_surveys, (survey) => {
      if (parseInt(_this.props.match.params.id, 10) === survey.id) {
        return survey
      }
    })
    if (survey) {
      return (
        <div className='survey-iframe' style={{ width: '100%'}}>
          <IframeResizer
            scrolling='yes'
            checkOrigin='false'
            style={{ width: '1px', minWidth: '100%' }}
            src={
              survey.url +
              '?is_frame=true&user_id=' +
              window.currentUser.user_id
            }
          />
          <div>
            <button
              className='cancel-button'
              style={{ marginTop: 10, maxWidth: '300px' }}
              onClick={() => {
                this.back()
              }}
            >
              {getLabel('done')}
            </button>
          </div>
        </div>
      )
    } else {
      return <div>Sorry No Survey Found</div>
    }
  }

  back() {
    this.props.getResource({
      key: 'events',
      update: true,
      callback: () => {
        window.location.href = '/evaluations'
      },
    })
  }

  render() {
    return (
      <div>
        <TitleBar
          title={getLabel('eval_event')}
          leftButtonLabel={this.state.backButton}
          leftButtonAction={this.back}
        />
        <h1>Event Evaluation</h1>
        <div className='survey-container'>
          <div className='spinner-container'>
            <div className='fa fa-spinner fa-spin'></div>
          </div>
          {this.getSurvey()}
        </div>
      </div>
    )
  }
}
